export const NGLSpotPriceConst = {
    SpotPrice_USD: 'SpotPrice_USD',
    Conversion_Factor:'Conversion_Factor',
    NGLSpotPrice:'NGLSpotPrice',  
    NGLTeamsSpotPrice:'NGLTeams.SpotPrice',
    NGLTeamsSpotPriceProduct:'NGLTeams.SpotPriceProduct' ,
    ReadOnlyColumns:['Created_By', 'Created_On', 'Updated_By', 'Updated_On', 'Effective_End','TargetEffectiveUntil'] 
  };
  